export function useShowLabel() {
    const isShowLabel = ref(false)

    onMounted(async () => {
        await timeout(1000)
        isShowLabel.value = true
    })

    const showLabel = (label: string) => (isShowLabel.value ? label : '')
    const showPlaceholder = (label: string) => label

    return {showLabel, showPlaceholder}
}
